//Built-In
import React from 'react';

//External
import { Col} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import cx from "classnames";

//Internal
import { showToast } from '../../Common/Appcommon';
import ReplyTemplate from './ReplyTemplate';

class ChatbotList extends React.Component{
    constructor(props) {
        super(props);
        let chatbotMessage = props.chatbotMessage;

        let chatBotData = {};
        this.state = {
            isChatBotModal: false,
            chatbotMSGId : chatbotMessage && Object.keys(chatbotMessage).length > 0 ? chatbotMessage['id'] : "",
            chatBotData : chatBotData,
            isOnChange : false,
        };
        this.toggleCampaignModal = this.toggleCampaignModal.bind(this);
    }

    toggleCampaignModal(id = "") {
        if(this.props.selectedFormName !== ''){
            this.props.chatbotModalState(!this.state.isChatBotModal, id);
            this.setState({
                isChatBotModal: !this.state.isChatBotModal,
            });
        }else{
            showToast("Please Select a Form","top-right","warning");
        }
    }

    chatBotMSGSaveOperation = async(chatbotMSGId) =>{
        await this.toggleCampaignModal(chatbotMSGId);
        await this.props.getNewCampaignIdList(chatbotMSGId);
    }

    enableEditChatBotMSG = async(chatbotMSGId) => {
        await this.setState({
            chatbotMSGId
        });
        this.toggleCampaignModal(chatbotMSGId);
    }

    render(){
        let {chatbotMessage,isValidCampaign, number, selectedFormName, isAddEnabled, isDelEnabled} = this.props;
        let {chatbotMSGId, isChatBotModal} = this.state;
        if(chatbotMessage === undefined){
            return (
                <div></div>
            )
        }

        this.state.isOnChange = false;
        let { useCForm, controller } = this.props;
        return (
            <div className={'campaigns-content'}>
                {/* this is class i demo for comment "messagebox-empty" */}
                <div className={cx('campaign-action', {'' : !isValidCampaign})}>
                    <div className={'d-flex-alone'}>
                        <div className={cx('campaign-action-number hide',{'' : number === 0})}>
                            <span>{number + 1}</span>
                        </div>
                        <Col md={"10"} className={'align-center'}>
                            {
                                Object.keys(chatbotMessage).length > 0 ?
                                    <div className={'d-flex-alone col-md-12'}>
                                        <div className={cx('col-md-9 display-align-center')}>
                                            <div className={cx('automation-campaign-link cursor-p')} onClick={(e) => {this.enableEditChatBotMSG(chatbotMessage['id'])}}>
                                                {chatbotMessage['name']}
                                            </div>
                                        </div>
                                    </div>
                                    : <div
                                        onClick={e => this.toggleCampaignModal()}
                                        className={
                                            cx("col-md-3 task-name text-truncate cursor-p",
                                                {"disabled-area" : selectedFormName === ''})}>
                                        Create Message
                                    </div>
                            }

                        </Col>
                        <Col md={'2'} className={cx('campaign-action-buttons',{'' : number === 0})}>
                            <div className={'form-group'}>
                                <div className={'form-row-action-buttons'}>
                                    {
                                        Object.keys(chatbotMessage).length > 0  && isAddEnabled && <FontAwesomeIcon onClick={(e) => {this.props.incrementChatbotMSGCount(e)}} icon={faPlus} />
                                    }
                                    {
                                        isDelEnabled && <FontAwesomeIcon icon={faTrash} onClick={(e) => {this.props.removeChatbotMSG(chatbotMessage['id'], number)}} />
                                    }
                                </div>
                            </div>
                        </Col>

                    </div>
                </div>
            </div>

        )
    }
}
export default ChatbotList;